<template>
    <!-- <svg viewBox="0 0 219 73" fill="none">
    <g clip-path="url(#clip0)">
      <path
        d="M1.10324 13.1889C1.27165 13.0927 1.51622 12.9629 1.88277 12.8091C2.37294 12.603 3.08891 12.3506 4.00919 12.1841C4.51597 12.0924 5.08117 12.0274 5.85843 12.0093C6.48575 11.9949 8.06307 11.9925 10.1174 12.3928C12.1157 12.7823 13.603 13.3643 14.296 13.6579C14.9452 13.9328 16.3211 14.5515 17.9081 15.6257C18.6112 16.1015 20.2225 17.2531 22.2924 19.5567C23.6414 21.0583 24.669 22.4743 26.5191 25.3893C28.0619 27.8198 29.587 30.2226 31.5055 33.7777C33.2025 36.9225 35.3802 41.2898 36.5351 44.0181C36.6302 44.243 37.2653 45.7484 38.1759 47.5727C38.709 48.6401 39.0749 49.2935 39.2326 49.5715C39.7224 50.4347 39.9676 50.8662 40.3224 51.4064C41.1157 52.6136 41.5334 52.9868 41.3902 53.2086C41.205 53.4956 40.2302 53.298 40.2014 53.0775C40.1892 52.9845 40.3398 52.8781 42.2707 52.1601C43.1681 51.8264 43.6724 51.6408 44.4282 51.3737C45.7446 50.9087 45.7282 50.8664 46.5416 50.5872C47.7431 50.1749 48.6379 49.9932 49.3596 49.8008C53.5468 48.6839 51.9158 49.0996 54.6661 48.3754C57.9712 47.5048 59.6239 47.0696 61.4676 46.6114C64.3955 45.884 66.4616 45.4252 70.1855 44.6019C75.0611 43.5234 77.4989 42.9845 80.048 42.5048C85.266 41.5228 89.2255 40.9962 90.395 40.8444C92.6754 40.5484 94.7135 40.3463 98.79 39.9418C100.774 39.745 98.8848 39.945 101.05 39.7523C104.193 39.4724 105.965 39.248 107.785 39.9418C107.955 40.0066 108.842 40.3526 108.799 40.5387C108.767 40.6792 108.222 40.647 107.566 40.6698C107.211 40.6821 106.506 40.7867 105.094 40.9959C101.241 41.5671 97.7986 42.261 97.7986 42.261C88.3981 44.0658 75.7012 47.1102 75.7012 47.1102C75.7012 47.1102 63.3132 50.311 48.5045 55.6137C47.3101 56.0415 46.0862 56.5537 45.617 56.7475C45.0366 56.9871 44.2937 57.2427 43.3715 57.7522C42.9961 57.9599 42.6947 58.1486 42.491 58.2765C40.8964 59.2781 40.6951 59.6772 40.2893 59.5871C39.9726 59.5169 39.8593 59.2328 39.1888 57.8833C38.5775 56.653 38.9011 57.4699 38.2642 56.136C36.9428 53.3688 35.1559 49.043 33.277 45.2829C33.2221 45.1728 33.2329 45.1953 31.8357 42.5483C26.6327 32.6909 26.5783 32.5619 26.0529 31.6491C23.1297 26.5705 20.7016 23.4254 20.1036 22.6534C19.2248 21.5188 17.3913 19.2233 14.5793 16.8203C12.438 14.9906 11.0018 14.1858 9.5507 13.6579C7.84821 13.0384 6.40618 12.9171 5.85843 12.883C5.11554 12.8371 4.0909 12.7808 2.8204 13.0578C1.16774 13.4185 0.0637669 14.1326 0.00246962 14.0191C-0.0460317 13.9294 0.630406 13.4592 1.10324 13.1889"
        fill="#C61E25"
      />
      <path
        d="M67.4995 65.0704C67.4995 69.4496 63.9218 73 59.5082 73C55.0949 73 51.5168 69.4496 51.5168 65.0704C51.5168 60.6908 55.0949 57.1407 59.5082 57.1407C63.9218 57.1407 67.4995 60.6908 67.4995 65.0704Z"
        fill="#C61E25"
      />
      <path
        d="M103.56 55.83C103.56 59.377 100.662 62.2524 97.0873 62.2524C93.5127 62.2524 90.615 59.377 90.615 55.83C90.615 52.2831 93.5127 49.4076 97.0873 49.4076C100.662 49.4076 103.56 52.2831 103.56 55.83Z"
        fill="#C61E25"
      />
      <path
        d="M49.8643 15.4816C47.9128 15.7783 46.402 16.5474 45.332 17.7889C44.2616 19.0301 43.7269 20.588 43.7269 22.4617V33.7051H39.4541V12.2961H43.7269V15.341C44.3559 13.6702 45.7095 12.5068 47.787 11.851L49.8643 15.4816"
        fill="#C61E25"
      />
      <path
        d="M57.4415 18.6437H71.5813C70.574 15.7392 68.2294 14.287 64.5468 14.287C60.8486 14.287 58.4802 15.7392 57.4415 18.6437V18.6437ZM56.6862 22.3446V22.4148C56.6862 24.6951 57.465 26.6077 59.0231 28.1535C60.581 29.6996 62.4223 30.4724 64.5468 30.4724C66.6554 30.4724 68.5044 29.6841 70.0942 28.1069C70.3143 27.8882 70.7394 27.3965 71.3689 26.631L75.3817 28.0363C74.7836 29.0359 74.0912 29.9185 73.3045 30.6834C70.9121 33.0725 67.9932 34.2671 64.5468 34.2671C61.1318 34.2671 58.2401 33.0924 55.8717 30.7419C53.5031 28.3918 52.3191 25.6163 52.3191 22.4148C52.3191 19.1824 53.5031 16.3951 55.8717 14.0526C58.2401 11.7104 61.1318 10.5392 64.5468 10.5392C67.9932 10.5392 70.9121 11.7262 73.3045 14.0996C75.3659 16.1607 76.397 18.9092 76.397 22.3446H56.6862"
        fill="#C61E25"
      />
      <path
        d="M82.0151 12.2961V3.98055H86.2641V12.2961H90.2772V15.95H86.2641V33.7051H82.0151V15.95H78.0022V12.2961H82.0151"
        fill="#C61E25"
      />
      <path
        d="M112.702 24.1014V20.6816C112.403 19.1355 111.687 17.8004 110.554 16.6761C108.964 15.0834 107.115 14.287 105.007 14.287C102.882 14.287 101.041 15.0679 99.4831 16.6292C97.9252 18.191 97.1462 20.1193 97.1462 22.4148C97.1462 24.6951 97.9252 26.6077 99.4831 28.1535C101.041 29.6996 102.882 30.4724 105.007 30.4724C107.115 30.4724 108.964 29.6841 110.554 28.1069C111.687 26.9826 112.403 25.6472 112.702 24.1014ZM116.975 33.7051H112.702V29.9573C111.018 32.8308 108.453 34.2671 105.007 34.2671C101.592 34.2671 98.7 33.0924 96.3317 30.7419C93.9631 28.3918 92.7791 25.6163 92.7791 22.4148C92.7791 19.1824 93.9631 16.3951 96.3317 14.0526C98.7 11.7104 101.592 10.5392 105.007 10.5392C108.453 10.5392 111.018 11.9602 112.702 14.8023V12.296H116.975V33.7051"
        fill="#C61E25"
      />
      <path
        d="M126.087 12.2961V33.7051H121.838V12.2961H126.087ZM126.146 6.19403C126.72 6.74845 127.007 7.36946 127.007 8.05626C127.007 8.77477 126.72 9.41125 126.146 9.9654C125.571 10.5198 124.851 10.7969 123.986 10.7969C123.089 10.7969 122.357 10.5198 121.791 9.9654C121.224 9.41125 120.941 8.77477 120.941 8.05626C120.941 7.36946 121.224 6.74845 121.791 6.19403C122.357 5.64014 123.089 5.36253 123.986 5.36253C124.851 5.36253 125.571 5.64014 126.146 6.19403Z"
        fill="#C61E25"
      />
      <path
        d="M135.742 -0.00132645V33.7051H131.469V-0.00132645H135.742Z"
        fill="#C61E25"
      />
      <path
        d="M146.742 16.6292C145.184 18.191 144.405 20.1193 144.405 22.4148C144.405 24.6951 145.184 26.6077 146.742 28.1535C148.3 29.6996 150.141 30.4724 152.266 30.4724C154.374 30.4724 156.212 29.6996 157.777 28.1535C159.343 26.6077 160.126 24.6951 160.126 22.4148C160.126 20.1193 159.343 18.191 157.777 16.6292C156.212 15.0679 154.374 14.287 152.266 14.287C150.141 14.287 148.3 15.0679 146.742 16.6292ZM152.266 10.5392C155.712 10.5392 158.607 11.7104 160.952 14.0526C163.297 16.3951 164.469 19.1824 164.469 22.4148C164.469 25.6163 163.297 28.3918 160.952 30.7419C158.607 33.0924 155.712 34.2671 152.266 34.2671C148.851 34.2671 145.959 33.0924 143.59 30.7419C141.222 28.3918 140.038 25.6163 140.038 22.4148C140.038 19.1824 141.222 16.3951 143.59 14.0526C145.959 11.7104 148.851 10.5392 152.266 10.5392Z"
        fill="#231F20"
      />
      <path
        d="M172.779 17.7302V33.7051H168.506V12.2961H172.779C173.503 11.5152 174.998 11.1248 177.264 11.1248C179.987 11.1248 182.182 11.9527 183.85 13.6075C185.518 15.2629 186.368 17.2851 186.4 19.6742V33.7051H182.151V19.8616C182.151 18.4094 181.655 17.203 180.663 16.2428C179.672 15.2823 178.539 14.8024 177.264 14.8024C176.005 14.8024 174.895 15.2553 173.936 16.1607C173.385 16.7076 172.999 17.2305 172.779 17.7302Z"
        fill="#231F20"
      />
      <path
        d="M195.606 -0.00132645V33.7051H191.333V-0.00132645H195.606Z"
        fill="#231F20"
      />
      <path
        d="M205.449 41.1304H200.846L206.464 29.1373L198.556 12.2961H203.159L208.777 24.1247L214.396 12.2961H218.999L205.449 41.1304Z"
        fill="#231F20"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="219" height="73" fill="white" />
      </clipPath>
    </defs>
  </svg> -->
    <!-- Generator: Adobe Illustrator 25.2.3, SVG Export Plug-In  -->
    <svg
        version="1.1"
        x="0px"
        y="0px"
        width="1158.7px"
        height="388.1px"
        viewBox="0 0 1158.7 388.1"
        style="overflow: visible; enable-background: new 0 0 1158.7 388.1"
        xml:space="preserve"
    >
        <g>
            <g>
                <path
                    class="st0"
                    d="M115.4,331l-1.1-12.3C108.3,253.1,91,138.6,75.2,98c-2.2-5.6-4.5-11.3-6.9-16.9c-2-4.6-4-9.1-6.2-13.5
			c-1.8-3.6-3.6-7.1-5.6-10.6c-1.6-2.8-3.3-5.5-5.1-8.1c-1.5-2.1-3.1-4.1-4.8-5.9c-1.8-2-3.9-3.8-6.1-5.3c-7.3-4.6-15.7-7-24.3-6.9
			h-1c-4.4,0.1-9.1,1-12.7,3.6c-0.9,0.7-1.8,1.5-2.5,2.3c3.1-3.9,7.5-6.7,12-8.6c11.2-4.9,23.8-5.8,34.7,0.2
			C64.3,37.9,75.2,57,83.5,74.5c10.1,21.4,16.2,44.2,20.9,67.3c2.4,12,4.5,24.1,6.7,36.2c3.6,19.9,6.9,39.9,9.7,60
			c2.7,18.4,5.2,36.9,7.3,55.4c0.4,3.9,0.9,7.8,1.3,11.7c31.2-15.5,221.9-76,278.3-57.3c-4.9-0.5-9.8-0.6-14.7-0.3
			c-6.1,0.3-12.2,1-18.3,1.9c-7.1,1-14.2,2.4-21.2,3.8c-7.9,1.6-15.7,3.4-23.5,5.4c-8.4,2.1-16.7,4.3-25,6.6
			c-8.6,2.4-17.2,4.9-25.8,7.5s-17.2,5.2-25.9,8c-8.5,2.7-16.9,5.4-25.3,8.2c-8,2.7-16,5.4-24,8.1c-7.3,2.5-14.7,5.1-22,7.7
			c-6.4,2.3-12.9,4.6-19.3,6.9c-11.8,4.3-23.7,8.4-35.2,13.5C123.3,327,119.3,328.9,115.4,331z"
                />
                <circle class="st0" cx="185.2" cy="357.8" r="30.3" />
                <circle class="st0" cx="358.2" cy="297.8" r="23.5" />
            </g>
            <path
                class="st0"
                d="M154.1,93.9h29.6v11.4c5.4-5.7,10.2-9.6,14.4-11.7c4.7-2.3,10-3.4,15.2-3.3c7.8,0,15.9,2.5,24.4,7.6L224.2,125
		c-5.6-4-11.1-6-16.4-6c-16.1,0-24.2,12.2-24.2,36.5v66.3H154L154.1,93.9L154.1,93.9z"
            />
            <path
                class="st0"
                d="M355.9,164.8h-91.7c0.8,10.5,4.2,18.8,10.2,25.1s13.8,9.3,23.2,9.2c7.3,0,13.4-1.8,18.3-5.3
		c4.8-3.5,10.2-10,16.1-19.4l25,13.9c-3.5,6-7.6,11.7-12.2,16.9c-4,4.5-8.7,8.4-13.8,11.6c-4.9,3-10.3,5.3-15.9,6.6
		c-6.1,1.4-12.3,2.1-18.5,2.1c-19.1,0-34.4-6.1-46-18.4c-11.5-12.3-17.2-28.6-17.2-49.1c0-20.2,5.6-36.6,16.8-49.1
		c11.3-12.4,26.3-18.5,44.9-18.5c18.8,0,33.7,6,44.6,18s16.4,28.5,16.3,49.5L355.9,164.8z M325.6,140.6
		c-4.1-15.8-14.1-23.6-29.8-23.6c-3.4,0-6.9,0.5-10.1,1.6c-3.1,1.1-6,2.7-8.6,4.7c-2.6,2.1-4.9,4.6-6.6,7.4c-1.9,3-3.3,6.4-4.2,9.9
		L325.6,140.6L325.6,140.6z"
            />
            <path
                class="st0"
                d="M407.6,121.5v100.3h-29.5V121.5h-12.7V93.9H378V47h29.5v46.9h23v27.6H407.6z"
            />
            <path
                class="st0"
                d="M533.9,93.9h29.7v127.9h-29.7v-13.4c-12.2,11.4-25.3,17.1-39.3,17.1c-17.7,0-32.3-6.4-43.9-19.2
		c-11.5-13.1-17.2-29.3-17.2-48.9c0-19.2,5.7-35.1,17.2-47.9c11.5-12.8,25.8-19.2,43.1-19.2c14.9,0,28.2,6.1,40.1,18.4V93.9z
		 M463.8,157.4c0,12.3,3.3,22.2,9.8,29.9c6.3,7.6,15.6,11.9,25.5,11.7c10.9,0,19.8-3.8,26.5-11.3c6.8-7.8,10.1-17.7,10.1-29.7
		s-3.4-21.9-10.1-29.7c-6.7-7.6-15.5-11.4-26.2-11.4c-9.8-0.2-19.2,4-25.5,11.5C467.1,136.3,463.8,146,463.8,157.4z"
            />
            <path
                class="st0"
                d="M583,40.7c0.1-10.5,8.7-19,19.2-19c5.1-0.1,10.1,2,13.7,5.7c3.7,3.5,5.7,8.4,5.7,13.5c0.1,5.1-2,10.1-5.6,13.7
		c-3.5,3.7-8.4,5.7-13.5,5.6c-10.6,0-19.3-8.6-19.3-19.2C583,40.9,583,40.8,583,40.7L583,40.7z M617,93.9v127.9h-29.6V93.9H617z"
            />
            <path class="st0" d="M670.5,0v221.8H641V0H670.5z" />
            <path
                class="st1"
                d="M688.4,156.9c0-18.5,6.6-34.2,19.8-47.1s29.3-19.4,48.3-19.4c19.1,0,35.3,6.5,48.6,19.6
		c13.1,13.1,19.7,29.1,19.7,48.1c0,19.2-6.6,35.2-19.8,48.2c-13.2,13-29.6,19.4-49,19.3c-19.2,0-35.2-6.6-48.2-19.7
		C694.9,192.8,688.4,176.5,688.4,156.9z M718.7,157.4c0,12.8,3.4,22.9,10.2,30.3c7,7.5,16.2,11.3,27.7,11.3s20.7-3.7,27.7-11.2
		c6.9-7.4,10.4-17.4,10.4-29.8c0-12.4-3.5-22.4-10.4-29.8c-7-7.5-16.2-11.3-27.7-11.3c-11.3,0-20.5,3.8-27.5,11.3
		C722.2,135.8,718.7,145.5,718.7,157.4L718.7,157.4z"
            />
            <path
                class="st1"
                d="M842.7,93.9h29.7v11.8c10.3-10.2,22-15.4,34.9-15.4c14.9,0,26.5,4.7,34.8,14.1c7.2,8,10.8,21,10.8,39v78.4
		h-29.7v-71.4c0-12.6-1.8-21.3-5.3-26.1c-3.4-4.9-9.6-7.4-18.7-7.4c-9.8,0-16.8,3.2-20.9,9.7c-4.1,6.5-6.1,17.6-6,33.5v61.7h-29.7
		V93.9H842.7z"
            />
            <path class="st1" d="M1006.3,0v221.8h-29.6V0H1006.3z" />
            <path
                class="st1"
                d="M1073,198l-57.6-104.1h34.3l39.1,73.5l36.5-73.5h33.4l-101.9,197.5H1023L1073,198z"
            />
        </g>
    </svg>
</template>

<style lang="scss" scoped>
@import '../../styles/mixins';
@import '../../styles/variables';

svg {
    height: 40px;
    width: auto;
}

@include mQ(900px) {
    svg {
        margin-top: 5px;
        height: 40px;
        width: auto;
    }
}

.st0 {
    fill: $accent-color;
}
.st1 {
    fill: $ro-grey;
}
</style>
